import React from 'react';
import './blog-post.css';
import video from "./pictures/decembervideo.mp4";
import dec1 from './pictures/dec1.jpg';
import dec2 from './pictures/dec2.jpg';
import dec3 from './pictures/dec3.jpg';
import dec4 from './pictures/dec4.jpg';
import dec5 from './pictures/dec5.jpg';
import dec6 from './pictures/dec6.jpg';
import dec7 from './pictures/dec7.jpg';


//import reportWebVitals from './reportWebVitals';

const December = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>A December to Remember with GEN1 Recap</h2>
                    <p class="site-post-meta">December 1st, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    On December 1st, WiC hosted December to Remember, a fun holiday social, in collaboration with UW GEN1. 
                    We kicked off the event with a fun holiday alphabet icebreaker where members of both clubs got to know each other 
                    and win exciting prizes. Afterward, members built gingerbread houses and enjoyed some sweet treats!

                    Thank you to WiC and GEN1 members for joining us in kicking off the holiday season! 
                    We are looking forward to seeing you at all of our other events, and we hope to 
                    see your continued support for both of our clubs.

                    <br></br>
                     
                    </p>
                    <video src={video} width="800" height="500" controls="controls" autoplay="false" />
                    <img src={dec1} alt="Group picture"/>
                    <img src={dec2} alt="Group picture"/>
                    <img src={dec3} alt="Group picture"/>
                    <img src={dec4} alt="Group picture"/>
                    <img src={dec5} alt="Group picture"/>
                    <img src={dec6} alt="Group picture"/>
                    <img src={dec7} alt="Gingerbread house"/>
 
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default December;

